import { render, staticRenderFns } from "./AuthorList.vue?vue&type=template&id=f8677ed2&"
import script from "./AuthorList.vue?vue&type=script&lang=js&"
export * from "./AuthorList.vue?vue&type=script&lang=js&"
import style0 from "./AuthorList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports